module.exports = __webpack_public_path__ + "8f1c161fb2b2bab0302d02d8b77a84d5.jpg";